import { Box, Typography, Card, CardContent, CardMedia, Button, Grid } from '@mui/material'
import React from 'react'
import securePass from '../img/webp/02-Usecase Section/img-secure-access.webp'
import complianeImg from '../img/webp/02-Usecase Section/img-compliane_and_insurance.webp'
import phishing1 from '../img/webp/02-Usecase Section/img-web-threat-protection.webp'
import phishing2 from '../img/webp/02-Usecase Section/img-prevent-phishing-attacks.webp'
import preventleaksImg from '../img/webp/02-Usecase Section/img-prevent-data-leak.webp'
import secureByodImg from '../img/webp/02-Usecase Section/img-byod-unmanaged-devces.webp'


import './css/ProtectIdentity.css'
import {ReactComponent as ArrowIcon} from "../img/visit-link-arrow.svg"
import { useNavigate } from 'react-router-dom'

export const ProtectIdentityCard = ({title, subtitle, imageLink}) => {
    return <>
<Card   sx={{ maxWidth: {lg: 384, sm: 702, xs: 702}, minWidth: {lg: 384, sm: 'fit-content', xs: '100%'}, minHeight: {md: 388, sm: 328, xs: 400}, maxHeight: 'fit-content', borderRadius: "12px", border: "2px solid #CEDCFF", boxShadow: "none" }}>
      <CardMedia
        component="img"
        sx={{
          height: 180, 
          maxWidth: '100%', 
          objectFit: 'cover', 
          transition: 'transform 0.3s', 
          transform: 'scale(1.8)',
          '&:hover': {
            transform: 'scale(2)',
          },
        }}
        image={imageLink || securePass} // Replace with your image source
        alt="green iguana" // Replace with your alt text
      />
      <CardContent sx={{ padding: '24px', position: "relative", zIndex: 1, background: "#FFFFFF" }}>
        <Typography gutterBottom variant="h5" component="div" sx={{
          fontFamily: 'Poppins',
          fontWeight: 600,
          minHeight: {md: 48, sm: 24, xs: 48},
          marginBottom: "12px",
          fontSize: {
            xs: '16px',
            sm: '20px',
            md: '20px',
            lg: '20px',
          },
          lineHeight: {
            sm: '120%',
            md: '120%',
            lg: '120%',
          },
        }}>
          {title || "Prevent Phishing Attacks"}
        </Typography>
        <Typography variant="body2" color="#6E6F70" sx={{
          fontFamily: 'Poppins',
          fontWeight: 400,
          fontSize: {
            xs: '16px',
            sm: '16px',
            md: '16px',
            lg: '16px',
          },
          lineHeight: {
            sm: '150%',
            md: '150%',
            lg: '150%',
          },
        }}>
          {subtitle || "Zaperon eliminates passwords and validates 15+ factors related to user, device and context, shielding your organization from phishing threats"}
        </Typography>
      </CardContent>
    </Card>
    </>
}
const ProtectIdentity = () => {
  const navigate = useNavigate()

  return (
    <Box
    component={'div'}
    className='protectIdentityBg'
  >
  <Box component={'div'} className=''>
      <Box display={"flex"} flexDirection="column" justifyContent={"center"} >
        <Typography
          variant="h2"
          sx={{
            p: {
              lg: "80px 0px 64px 0px",
              md: "80px 0px 64px 0px",
              sm: "80px 0px 80px 0px",
              xs: "48px 0px 32px 0px",
            },
            font: {
              lg: "normal normal 600 48px/120% Poppins",
              md: "normal normal 600 48px/120% Poppins",
              sm: "normal normal 600 48px/120% Poppins",
              xs: "normal normal 600 20px/120% Poppins",
            },
            color: "#0B3558",
            textAlign: "center"
          }}
        >
        Zero Trust. Zero Hackers.
        </Typography>
          
        <Box>
        <Grid width={{lg:'1200px', md: "800px"}} container sx={{ marginLeft: {md: "auto", xs: "auto"},marginRight: "auto", '& > *': { padding: {xs: '16px',sm: "32px"} } }}>
      {/* Each ProtectIdentityCard component will occupy half of the grid on md screens */}
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Prevent Phishing Attacks'} subtitle={'Eliminate passwords and validate 15+ MFA factors related to user behaviour and device posture to combat account takeover'} imageLink={phishing2}/>
      </Grid>
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Secure Access to Resources'} subtitle={'Protect enterprise resources - apps (saas, on-prem, desktop), servers & network device, from unauthorized access'} imageLink={securePass} />
      </Grid>
     
     
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Control Access from BYOD'} subtitle={'Secure access to applications and data from unauthorized users and unmanaged devices'} imageLink={secureByodImg}/>
      </Grid>
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Protect Sensitive Data on Cloud & Endpoints'} subtitle={'Prevent unauthorized access and data leakage from cloud applications and user endpoints'} imageLink={preventleaksImg}/>
      </Grid>
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Protect Against Web-based Threat'} subtitle={'Monitor internet traffic continuously to block malicious URLs and malware and block access to unsanctioned apps'} imageLink={phishing1}/>
      </Grid>
      <Grid item xs={12} md={4}>
        <ProtectIdentityCard title={'Comply with Regulations & Insurance Needs'} subtitle={'Meet compliance requirement of GDPR, PCI-DSS, HIPAA, SOX, GBLA, RBI, SEBI, and IRDAI  and lower cyber insurance cost'} imageLink={complianeImg}/>
      </Grid>
    </Grid>
    <Box sx={{marginLeft: "auto", marginRight: "auto", width: 'fit-content'}}>
    <Button onClick={() => navigate('/useCases')} variant="contained" endIcon={<ArrowIcon fill='#FFF' />} sx={{marginTop: "32px", marginBottom: "64px", minWidth: {xs: "85vw", lg: "305px"}, background: "#003FB9", textTransform: "capitalize", width: 'fit-content', height: 48, fontWeight: '600', fontSize: {sm: "20px", xs: "16px"}, lineHeight: "24px", fontFamily: "Poppins", marginRight: "auto", marginLeft: "auto"}}>Explore Use Cases</Button>
    </Box>
    </Box></Box>
    </Box></Box>
  )
}

export default ProtectIdentity